import { takeLatest, call, put } from 'redux-saga/effects';
import { POST_ABOUT_US_START, POST_ABOUT_US_ERROR, POST_ABOUT_US_SUCCESS, GET_ABOUT_US_START } from '../../types';

import apiCall from '../../../api';

export function* create({ payload }) {
  try {
    const url = '/about-us/create';
    const method = 'POST';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: POST_ABOUT_US_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: POST_ABOUT_US_ERROR, error });
  } finally {
    yield put({ type: GET_ABOUT_US_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1)
  }
}

export default function* post_about_us() {
  yield takeLatest(POST_ABOUT_US_START, create);
}
